<div *ngIf="percentage | async as pct"></div>

<div *ngIf="(snapshot | async) as snap"></div>
